import { getColor } from 'common/constants/_colors';
import { RADIUS, SIZES } from 'common/constants/sizes';
import styled, { css } from 'styled-components';

export const StyledFilterSetForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 3rem;
  width: 40rem;
`;

const CommonSectionStyle = css`
  margin-bottom: 1rem;
`;

export const StyledHeader = styled.div`
  margin-bottom: 4rem;
  font-size: ${SIZES['x-large']};
`;

export const StyledTypeSelection = styled.div`
  ${CommonSectionStyle}
`;

export const StyledSectionTitle = styled.div`
  margin-bottom: 1rem;
  font-size: ${SIZES.medium};
  text-transform: uppercase;
`;

export const StyledLabel = styled.div`
  font-size: ${SIZES.medium};
  color: #808080;
`;

export const StyledDescription = styled.div`
  font-size: ${SIZES.medium};
  color: #808080;
  margin-top: 1rem;
  margin-bottom: 1rem;
  line-height: 1.7rem;
`;

export const StyledNameSelector = styled.div`
  ${CommonSectionStyle}
`;

export const StyledVisibilitySelector = styled.div`
  margin-bottom: 2rem;
`;

export const StyledDueDateSelector = styled.div`
  ${CommonSectionStyle}
`;

export const StyledInputDate = styled.input`
  width: 90%;
  height: 3rem;
  border-radius: ${RADIUS.small};
  border: 1px solid ${getColor('botticelli')};
  padding-left: 1rem;
  font-size: 1.3rem;
  &::-webkit-calendar-picker-indicator {
    margin-right: 1rem;
  }
`;

export const StyledErrorMessage = styled.div`
  color: red;
  font-size: ${SIZES.small};
  height: 1.1rem;
  margin-top: 1rem;
  &.hidden {
    visibility: hidden;
  }
`;
